import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getById, getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetPunchoutApiParameter } from "@TKCCP/Services/tkccpPunchoutService";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import { createContext } from "react";

export function getPunchoutDataView(state: ApplicationStateTKCCP, getPunchoutParameter: GetPunchoutApiParameter) {
    return getDataView(state.datapunchoutsecret, getPunchoutParameter);
}

export const PunchoutDataViewContext = createContext<ReturnType<typeof getPunchoutDataView>>({
    value: undefined,
    isLoading: false,
});
